import React, { Fragment } from 'react';

export default {
  title: <Fragment>Schwarz-Rot</Fragment>,
  duration: 'Dezember 2013 - heute',
  startDate: new Date(2013, 11, 16),
  endDate: new Date(2019, 10, 30),
  description: 'Juniorpartner',
  description_long: '2013 tritt die SPD wieder in eine Groko ein und verlängert 2018, nachdem Verhandlungen über eine Jamaika-Koalition gescheitert sind. Doch die Groko-Frage spaltet schon lange die Partei. In den Umfragen ist die SPD im freien Fall und der Vorsitz wieder ein Schleudersitz.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(2017, 2, 18),
      y: 31.5
    },
    coordsMobile: {
      x: new Date(2017, 2, 18),
      y: 34
    },
    kicker: '19. März 2017',
    title: (<h3>Martin Schulz <em>(331 Tage)</em></h3>),
    text:
      <p>
        <span className="media">
          <img src="images/chronik/09-2017-schulz.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">picture alliance/AP</span>
          </span>
        </span>
       Der neue Messias der SPD heißt Martin Schulz. Auf einem Sonderparteitag wird er zum Chef gewählt - mit 100-Prozent. 
       Seitdem Gabriel den Europapolitiker aus Würselen zu seinem Nachfolger und Kanzlerkandidaten vorgeschlagen hat, rast der Schulzug an Merkel vorbei. 
       Und eine Eintrittswelle erfasst die SPD. Nun ist er auf dem Umfragegipfel, stürzt von dort aber rasant in die Tiefe.

      </p>,
      additional: (<ul>
          <li><strong>Umfragehoch: </strong>33&nbsp;Prozent (Emnid) am 25. März 2017</li>
          <li><strong>Umfragetief: </strong>17&nbsp;Prozent (Forsa) am 22. Januar 2018</li>
        </ul>)
  }, {
    milestone: false,
    coords: {
      x: new Date(2017, 8, 23),
      y: 20
    },
    coordsMobile: {
      x: new Date(2017, 8, 23),
      y: 19
    },
    kicker: '24. September 2017',
    title: 'SPD so schlecht wie nie bei einer Bundestagswahl',
    text:
      <p>
      Die Bundestagswahl verändert das Parlament gewaltig. Erstmals zieht mit der AfD eine Partei rechts von der Union ein. 
      Die Volksparteien erleiden Verluste, Merkel ist dennoch klare Wahlsiegerin. Die SPD erzielt mit 20,5 Prozent ihr historisch schlechtestes Ergebnis. 
      Ex-Hoffnungsträger Schulz erklärt noch am Wahlabend den Gang in die Opposition und schließt kategorisch aus, Minister unter Merkel werden zu wollen.
      </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2018, 1, 12),
      y: 17
    },
    coordsMobile: {
      x: new Date(2018, 1, 12),
      y: 14
    },
    kicker: '13. Februar 2018',
    title: 'Olaf Scholz wird kommissarischer SPD-Chef',
    text:
      <p>
      Nach dem Scheitern der Jamaika-Verhandlungen macht die SPD-Führung eine 180-Grad-Wende in Sachen Groko. 
      Dagegen formiert sich eine innerparteiliche Protestbewegung - angeführt von Juso-Chef Kevin Kühnert. 
      Die Groko soll kommen, aber auch das Ende von Schulz an der SPD-Spitze. 
      Er verzichtet zugunsten von Andrea Nahles auf den Vorsitz. Für 68 Tage übernimmt Olaf Scholz kommissarisch.
      </p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2018, 3, 1),
      y: 14.5
    },
    coordsMobile: {
      x: new Date(2019, 3, 1),
      y: 12.5
    },
    kicker: '2. April',
    title: (<h3>Andrea Nahles <em>(427 Tage)</em></h3>),
    text:
    <p>
      <span className="media">
          <img src="images/chronik/11-2018-nahles.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
      </span>
      Premiere bei der ältesten Partei Deutschlands:  Mit Andrea Nahles wird erstmals eine Frau zur SPD-Vorsitzenden gewählt. 
      Doch die Zustimmungswerte für die SPD steigen nicht, Nahles gerät unter Druck. 
      Nach dem schlechten Ergebnis bei der Europawahl 2019 (15,8 Prozent) zieht sich Nahles komplett aus der Bundespolitik zurück. 
      Sie tritt als Partei- und Fraktionschefin ab und legt später auch ihr Bundestagsmandat nieder.
      </p>,
      additional: (<ul>
          <li><strong>Umfragehoch: </strong>21&nbsp;Prozent (Allensbach) am 20. Juni 2018</li>
          <li><strong>Umfragetief: </strong>12&nbsp;Prozent (Forsa) am 1. Juni 2019</li>
        </ul>)
  }, {
    milestone: false,
    coords: {
      x: new Date(2019, 5, 2),
      y: 13.5
    },
    coordsMobile: {
      x: new Date(2019, 5, 2),
      y: 10
    },

    kicker: '3. Juni 2019',
    title: 'Ein Trio für die kopflose SPD',
    text:
    <p>
      Von ihrem Wahltriumph 1998 bis heute zu Tiefstwerten von 11 Prozent (Forsa, 15. Juni 2019) hat die SPD neun Parteichefs verschlissen.
      Nach dem plötzlichen Rückzug von Nahles teilt sich ein Trio die Verantwortung an der kommissarischen Parteispitze: Manuela Schwesig, Malu Dreyer und Thorsten Schäfer-Gümbel. 
      Niemand reißt sich zunächst offen um den SPD-Vorsitz. Die Partei entscheidet sich dann für die Suche nach einer Doppelspitze - mit Castingshows bei der Basis und Mitgliederbefragungen.
      </p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2019, 11, 5),
      y: 12
    },
    coordsMobile: {
      x: new Date(2019, 11, 5),
      y: 8
    },

    kicker: '30. November 2019 (Verkündung)',
    title: (<h3>Saskia Esken und Norbert Walter-Borjans</h3>),
    text:
    <p>
      <span className="media">
          <img src="images/chronik/13-2019-esken-walter-borjans.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Das Sieger-Paar</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
      </span>
      Nach 23 Regionalkonferenzen, einem Vorlauf und einer Stichwahl hat die SPD nun ihr Traumpaar gefunden: 
      Saskia Esken und Norbert Walter-Borjans sollen die SPD aus dem Umfragetief führen. 
      Die neue Doppelspitze setzte sich gegen Olaf Scholz und Klara Geywitz mit 53 Prozent der Stimmen bei der finalen Mitgliederbefragung durch. 
      Wie es durch ihre Wahl mit der Groko weiter geht, ist ungewiss.
      </p>
  }
  ]
};